import { type ReactNode, useEffect, useRef } from 'react';
import s from './plain-modal.module.scss';

interface Props {
    open: boolean;
    onBackdropClicked?: () => void;
    children: ReactNode;
}

export default function PlainModal({ open, children }: Props) {
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (dialogRef.current?.open && !open) {
            dialogRef.current.close();
            return;
        }
        if (!dialogRef.current?.open && open) {
            dialogRef.current?.showModal();
        }
    }, [open]);

    return (
        <dialog className={s.dialogContainer} ref={dialogRef}>
            {children}
        </dialog>
    );
}
